import { useState, useEffect } from 'react'
import { Button, Stack, TableCell, TableRow } from '@mui/material'
import { Item } from '../../../common/snippets'
import { Box, useTheme } from '@mui/system'
import { excelHeader, lrDetailsColumns, lrDetailsDataFormat } from './constants'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import moment from 'moment'
import * as id from '../reportId'
import { focusElemnt, navigation3 } from '../../../common/helper'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
import useToken from '../../../helpers/useTokens'
import VirtualizedTable from '../../../common/virtualisedTable'
import { divideInNIntegers } from '../../../common/mathHelper'
import { exportToExcel } from '../../../common/hook'
import { makeTable } from './pdfAutotable'
import { xlCol } from '../../../common/constants'
import { lrDetailPdfFooter } from '../onAccountCreditReport/const'

const reportname = 'Analysis Report'

const LRDetails = (props) => {
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const { tableData, headerData } = props
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  const { AllowExportExcel } = { ...roleRightsData }
  const { loginData } = useToken()
  const [companySettings] = useAtom(companySettingsAtom)
  const { UseFormattedLRinReports } = companySettings
  const [showTableData, setShowTableData] = useState([])
  const [searchResult, setSearchResult] = useState(true)
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
  const indicesToRemove = UseFormattedLRinReports === 3 ? [2] : UseFormattedLRinReports === 2 ? [1, 3] : [2, 3]
  const headerColumns = lrDetailsColumns.filter((_, index) => !indicesToRemove.includes(index))
  const viewHeader = headerColumns.map((a) => ({ ...a, field: a.field === 'Status' ? 'StatusView' : a.field }))

  const span1 = divideInNIntegers(headerColumns.length, 2)

  const header1 = [
    [
      { header: `Report For: ${reportname} Report`, field: '', span: span1[0], mainHeader: true },
      { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: span1[1] },
    ],
  ]
  const excelHeaderList = [header1, excelHeader]
  const excelDataList = [[], [headerData]]

  const excelHeaders = headerColumns.flatMap((col) => {
    if (typeof col.field === 'string' && col.field.includes('^^')) {
      const [field1, field2] = col.field.split('^^')
      const [header1, header2] = (col.exportHead || '').split('\n')
      return [
        { field: field1, header: header1, align: col.align },
        { field: field2, header: header2, align: col.align },
      ]
    }
    return { field: col.field, header: col.exportHead, align: col.align }
  })
  excelHeaderList.push(excelHeaders)

  const lengths = divideInNIntegers(excelHeaders.length, 3)
  let index = 0
  const pickedHeaders = []
  lengths.forEach((span) => {
    pickedHeaders.push(excelHeaders[index].field)
    index += span
  })
  const excelTableData = showTableData.map((row) => {
    if (row.dataType === 'subHeader') {
      const colSpan = row.colSpan
      const orderedKeys = headerColumns
        .map((c) => c.field)
        .filter((key) => key in colSpan)
        .map((key) => row[key])
      return {
        ...row,
        ...Object.fromEntries(pickedHeaders.map((key, i) => [key, orderedKeys[i]])),
        colSpan: Object.fromEntries(pickedHeaders.map((key, i) => [key, lengths[i] || 1])),
        align: { [pickedHeaders[0]]: 'left', [pickedHeaders[1]]: 'center', [pickedHeaders[2]]: 'right' },
      }
    }
    if (row.dataType === 'total') {
      return {
        ...row,
        colSpan: { [pickedHeaders[0]]: excelHeaders.findIndex((header) => header.field === 'Items') },
        align: { [pickedHeaders[0]]: 'right' },
      }
    }
    return row
  })
  excelDataList.push(excelTableData)
  useEffect(() => {
    if (tableData?.length > 0) {
      const formatedData = lrDetailsDataFormat(tableData, headerColumns, headerData)
      setShowTableData(formatedData)
    } else {
      setShowTableData([])
    }
  }, [tableData])

  const printClick = (isSave) => {
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = excelHeader.map((col) => {
      return { header: col.header, dataKey: col.field, xlCol: col.xlCol || xlCol }
    })
    const pdfColumns = headerColumns.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfFontSize = 1
    const doc = new jsPDF({ orientation: 'p', format: [1280, 1810], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Analysis Reports.pdf`,
      subject: 'Analysis  Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    const customFunction = (data, doc) => {
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(18).setFont('Roboto', 'bold')
      doc.text(`Booking Date: ${headerData.fromDate}  To  ${headerData.toDate} `, data.settings.margin.left, 150)
      doc.text(`Report View: Summary`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
    }
    const customFunction2 = (data, doc) => {
      doc.setTextColor(40)
      doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
      doc.setFontSize(26).setFont('Roboto', 'bold')
      doc.setTextColor(16, 79, 162)
      doc.text('Cargo System | Analysis Report', 30 + 60, 80)
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(22).setFont('Roboto', 'bold')
      doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
      lrDetailPdfFooter(data, loginData, totalPagesExp)
    }
    makeTable(doc, autoTable, HeaderColumns, [headerData], pdfFontSize, reportname, loginData, 'everyPage', customFunction, 160, false)
    makeTable(doc, autoTable, pdfColumns, showTableData, pdfFontSize, reportname, loginData, 'everyPage', customFunction2)

    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${reportname} ${currentDateTime}.pdf`)
    } else {
    }
    setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      const pdfUrl = doc.output('bloburl')
      document.getElementById('anaLRDetailsOutput').data = pdfUrl
      // document.getElementById('anaLRDetailsOutput').data = doc.output('datauristring', ' Analysis Reports.pdf')
      focusElemnt('backBtn')
    }, 2000)
  }
  const headerContent = () => {
    return (
      <>
        <TableRow>
          {headerColumns.map((item) => {
            return (
              <TableCell
                style={{
                  backgroundColor: '#e5f3ff',
                  color: '#444',
                  fontSize: '12px',
                  lineHeight: '16px',
                  letterSpacing: '0.24px',
                  fontWeight: '600',
                  whiteSpace: 'pre-line',
                  padding: '6px 8px',
                  width: item.width,
                  textAlign: item.align || 'left',
                }}
                colSpan={1}
              >
                {item?.header}
              </TableCell>
            )
          })}
        </TableRow>
      </>
    )
  }
  const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs }) => {
    if (!row?.dataType) return null
    const getStyles = (field, align) => {
      const common = {
        minHeight: '36px',
        fontSize: '12px',
        color: '#444',
        padding: '6px 8px',
      }
      if (row.dataType === 'entry') {
        return {
          ...common,
          fontWeight: '500',
          textAlign: align || 'left',
          height: '36px',
        }
      }
      if (row.dataType === 'subHeader') {
        return {
          ...common,
          fontWeight: '600',
          backgroundColor: tableHeaderColor?.isSubHeadingColor,
          textAlign: row.align?.[field] || 'left',
          position: 'sticky',
        }
      }
      if (row.dataType === 'total') {
        return {
          ...common,
          fontWeight: '600',
          backgroundColor: tableHeaderColor?.isTotalColor,
          textAlign: row.align?.[field] || 'right',
        }
      }
    }

    return (
      <>
        {(() => {
          let skip = 0

          return columnDefs.map((item, i) => {
            if (skip > 0) {
              skip--
              return null
            }
            const colSpan = row.colSpan?.[item.field] || 1
            skip = colSpan - 1
            return (
              <TableCell className="reportTD" key={item.field + i + index} colSpan={colSpan} style={getStyles(item.field, item.align)}>
                {row[item.field]}
              </TableCell>
            )
          })
        })()}
      </>
    )
  }
  const bodyContent = (index, obj) => {
    return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={viewHeader} />
  }
  return (
    <>
      <Stack style={{ margin: '0px 10px', marginRight: '0px' }}>
        <Item className="userReport">
          <Item className="userReport-heading">Report For: Analysis Report - LR Details with Status</Item>
          <Item className="userReport-buttons">
            {searchResult ? (
              <>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    disabled={!AllowExportExcel}
                    onClick={() =>
                      exportToExcel({
                        fileName: `Analysis Report ${currentDateTime}.xlsx`,
                        sheetName: 'Analysis Report',
                        headersList: excelHeaderList,
                        dataList: excelDataList,
                      })
                    }
                  >
                    Export to Excel
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(false)
                      // if (showTableData?.length > 200) {
                      //     setLargePDF(true)
                      // } else {
                      //     printClick(true)
                      // }
                      printClick(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, 'analPrintBtn', !AllowExportExcel ? id.anSplitButton : 'analsExpToExlbtn', () => {
                        setSearchResult(false)
                        printClick(true)
                      })
                    }
                    id="anaxportAsPdfBtn"
                  >
                    Export to Pdf
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(false)
                      // if (showTableData?.length > 200) {
                      //     setLargePDF(true)
                      // } else {
                      //     printClick(false)
                      // }
                      printClick(false)
                    }}
                    id="analPrintBtn"
                    onKeyDown={(e) =>
                      navigation3(e, id.fromDate, 'anaxportAsPdfBtn', () => {
                        setSearchResult(true)
                        printClick(false)
                      })
                    }
                  >
                    Print
                  </Button>
                </Box>
              </>
            ) : (
              <>
                <Box>
                  <Button
                    id="backBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    onClick={() => {
                      setSearchResult(true)
                    }}
                    onKeyDown={(e) =>
                      navigation3(e, id.fromDate, id.anSplitButton, () => {
                        setSearchResult(true)
                        focusElemnt(id.anSplitButton)
                      })
                    }
                  >
                    Back
                  </Button>
                </Box>
              </>
            )}
          </Item>
        </Item>
      </Stack>
      {searchResult ? (
        <VirtualizedTable
          tableData={showTableData}
          headerContent={headerContent}
          rowContent={bodyContent}
          tableStyle={{ tableLayout: 'auto', width: '100%' }}
          autoResize={true}
        />
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="anaLRDetailsOutput"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}

export default LRDetails
